import styled from 'styled-components';
import { rem } from 'polished';

export const numberedListCounterSize = 34;

const NumberedList = styled.ul`
  padding: 0;
  margin: 0 0 0 ${rem(numberedListCounterSize / 2)};
  list-style-type: none;
  counter-reset: page-list-counter;
`;

export const NumberedListItem = styled.li`
  position: relative;
  padding: 4px 0 10px 40px;
  border-left: 2px solid ${({ theme: { numberedList } }) => numberedList.color};

  &:last-child {
    border-left: none;
  }

  &::before {
    content: counter(page-list-counter);
    counter-increment: page-list-counter;
    position: absolute;
    left: -${rem(numberedListCounterSize / 2)};
    top: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: ${rem(numberedListCounterSize)};
    height: ${rem(numberedListCounterSize)};
    border-radius: 50%;
    font-size: 18px;
    font-weight: 700;
    background-color: ${({ theme: { numberedList } }) =>
      numberedList['background-color']};
    border: 2px solid ${({ theme: { numberedList } }) => numberedList.color};
    color: ${({ theme: { numberedList } }) => numberedList.color};
  }
`;

export default NumberedList;
